import { ArrowRight } from "lucide-react";
import { DTORBIT_URL } from "@/constants";
import RateCard from "./RateCard";
import { Reveal } from "./Reveal";

export default function LiveRateSection({ rate }) {
    const formatted =
        rate.rate !== null && rate.rate !== undefined
            ? `₹${Number(rate.rate).toFixed(2)}`
            : null;

    return (
        <section
            id="live-rate"
            data-testid="live-rate-section"
            className="relative py-16 md:py-24 scroll-mt-20"
        >
            <div className="pointer-events-none absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[560px] h-[320px] rounded-full bg-[#DCEAFF] blur-[120px]" />
            <div className="relative max-w-7xl mx-auto px-4 sm:px-6 grid lg:grid-cols-2 gap-10 items-center">
                <Reveal>
                    <div>
                        <span className="text-xs uppercase tracking-[0.25em] text-[#1E56FF] font-bold">
                            Live Rate
                        </span>
                        <h2 className="font-display mt-3 text-3xl md:text-4xl font-bold tracking-tight text-[#0F1B3D]">
                            Live USDT to INR Exchange Rate
                        </h2>
                        <p className="mt-4 text-sm md:text-base text-[#5B6B8C] leading-relaxed max-w-lg">
                            Get the current USDT to INR exchange rate before
                            starting your exchange. The rate on this page is
                            fetched live from DtOrbit and updates automatically
                            {formatted
                                ? ` — right now, 1 USDT = ${formatted} INR.`
                                : "."}
                        </p>
                        <a
                            href={DTORBIT_URL}
                            data-testid="live-rate-start-exchange-button"
                            className="btn-primary mt-7"
                            aria-label="Exchange USDT to INR on DtOrbit"
                        >
                            Exchange USDT to INR
                            <ArrowRight className="w-4 h-4" />
                        </a>
                    </div>
                </Reveal>
                <Reveal delay={150}>
                    <RateCard rate={rate} large />
                </Reveal>
            </div>
        </section>
    );
}
